import { render, staticRenderFns } from "./popup-zi-duan.vue?vue&type=template&id=4cf20f75&scoped=true"
import script from "./popup-zi-duan.vue?vue&type=script&lang=js"
export * from "./popup-zi-duan.vue?vue&type=script&lang=js"
import style0 from "./popup-zi-duan.vue?vue&type=style&index=0&id=4cf20f75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf20f75",
  null
  
)

export default component.exports